function Scroller(){

    console.log("Scroller");

    var self = this;

    var controller = new ScrollMagic.Controller();

    self.active="#e30613";
    self.colour="#002475";

    var size = new BrowserSize();

    function getOffset(){

        self.size = size.getWindowSize();
        self.offset = (self.size.height - 700)/2;

    }

    getOffset();

    $( window ).resize(function() {

        getOffset();
    });

    controller.scrollTo(function (newpos){

        console.log("newpos " + newpos);
        console.log("self.offset " + self.offset);

        TweenMax.to(window, 0.5, {scrollTo: {y: newpos-self.offset}, ease:Power2.easeInOut});

    });

    //  bind scroll to anchor links
    $(document).on("click", "a[href^='#']", function (e) {
        var id = $(this).attr("href");
        if ($(id).length > 0) {
            e.preventDefault();

            // trigger scroll
            controller.scrollTo(id);

            // if supported by the browser we can even update the URL.
            if (window.history && window.history.pushState) {
                history.pushState("", document.title, id);
            }
        }
    });

    self.currentSection ="";



    function selectNavElement(e, hashElementID, id){

        if(e.type ==="enter"){

           console.log("enter " + hashElementID);

            TweenMax.to(hashElementID, 0.25, {width:"70px",ease:Sine.easeInOut, delay:0.1});
            TweenMax.to($("span", hashElementID), 0.15, {css:{backgroundColor:self.active},ease:Sine.easeInOut });

            self.currentSection = "n" + id;

        } else {

            console.log("leave " + id);

            TweenMax.killTweensOf(hashElementID);

            TweenMax.to(hashElementID, 0.35, {width:"35px",ease:Sine.easeInOut});
            TweenMax.to($("span", hashElementID), 0.15, {css:{backgroundColor:self.colour},ease:Sine.easeInOut });
        }
    }

    function showNav(e){

        if(e.type ==="enter"){


            TweenMax.to(".side-nav", 0.75, {autoAlpha:1});
        } else {

            TweenMax.to(".side-nav", 0.75, {autoAlpha:0});
        }

    }
    TweenMax.set(".side-nav", {autoAlpha:0});

    var hashTriggerInID = "#s1";

    var sceneIn = new ScrollMagic.Scene({triggerElement: hashTriggerInID, triggerHook: 0.5, offset: -50})

        //.addIndicators()
        .on("enter leave",  function (event) {

            showNav(event);

        })

        .addTo(controller);



    $(".screen").each(function( index ) {

        var id = index + 1;

        console.log("----------------------------- screen " + id );

        //var triggerID = "s" + id;
        //var elementID = "n" + id;

        var hashTriggerInID = "#s" + id;
        var hashTriggerOutID = "#o" + id;
        //var hashElementID = "#n" + id + " span";

        var hashElementID = "#n" + id;


        var sceneIn = new ScrollMagic.Scene({triggerElement: hashTriggerInID, duration:700, triggerHook: 0.5, offset: 0})

            //.addIndicators()
            .on("enter leave",  function (event) {

                selectNavElement(event, hashElementID, id);

            })

            .addTo(controller);

     /*
        /*var scene = new ScrollMagic.Scene({triggerElement: "#trigger3", duration: 200, offset: -50})
            .setTween(tween)
            .addIndicators({name: "tween css class"}) // add indicators (requires plugin)
            .addTo(controller);*/


    });


    $(".nav-link").each(function( index ) {

        var id = $(this).attr('id');

        $(this)
            .mouseover(function() {

                //TweenMax.to($(this), 0.15, {width:"70px",ease:Sine.easeInOut })
                TweenMax.to($(this), 0.15, {width:"70px",ease:Sine.easeInOut });
                TweenMax.to($("span", this), 0.15, {css:{backgroundColor:self.active},ease:Sine.easeInOut });

            })
            .mouseout(function() {

                if (id === self.currentSection) {



                } else {

                    TweenMax.to($(this), 0.35, {width: "35px", ease: Sine.easeInOut});
                    TweenMax.to($("span", this), 0.15, {css:{backgroundColor:self.colour},ease:Sine.easeInOut });
                }

            });

    });



    //TweenMax.set('.nav-link span', {autoAlpha:0});



}
